<div class="heatmap-card">
    <div class="heatmap-header">
        <h3 class="chart-title">{{ 'user_records.analytics.heatmap_title' | translate }}</h3>
        <div class="layer-tabs">
            <button *ngFor="let tab of layerTabs"
                    class="layer-tab"
                    [class.active]="selectedLayer === tab.value"
                    (click)="onLayerChange(tab.value)">
                {{ tab.label }}
            </button>
        </div>
    </div>
    <div class="heatmap-container">
        <div id="user-analytics-heatmap" class="map"></div>
        <div *ngIf="activePoints.length === 0" class="no-data-overlay">
            {{ 'user_records.analytics.no_data' | translate }}
        </div>
    </div>
    <div class="heatmap-footer">
        <span class="point-count">{{ activePoints.length }} {{ 'user_records.analytics.heatmap_points' | translate }}</span>
    </div>
</div>
